import { ReviewLoadingOnboarding } from "@/components/review-loading-onboarding";
import { Button } from "@/toggle-ui-kit/button";
import { BarLoader } from "@/toggle-ui-kit/loader";
import type { ReactNode } from "react";

export const ReviewDocumentShell = ({ children }: { children: ReactNode }) => (
  <div className="flex h-screen flex-col bg-background-neutral-normal">
    <main className="flex min-h-0 flex-1 overflow-hidden">
      <div className="flex h-full min-h-0 w-full flex-col">{children}</div>
    </main>
  </div>
);

const ReviewDocumentMessagePanel = ({
  children,
  centered = false,
}: {
  children: ReactNode;
  centered?: boolean;
}) => (
  <div
    className={
      centered
        ? "flex min-h-[320px] flex-col items-center justify-center gap-4 rounded-[8px] border border-line-normal bg-background-base px-6 text-center"
        : "flex min-h-[320px] items-center justify-center gap-2 rounded-[8px] border border-line-normal bg-background-base px-6 text-center"
    }
  >
    {children}
  </div>
);

export const ReviewDocumentLoadingState = () => (
  <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 bg-background-base px-6">
    <ReviewLoadingOnboarding />
    <BarLoader size="lg" color="#171717" />
  </div>
);

export const ReviewDocumentErrorState = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) => (
  <ReviewDocumentMessagePanel centered>
    <p className="body-2-normal-medium text-status-negative">{message}</p>
    <Button variant="outlined" color="secondary" size="base" onClick={onRetry}>
      다시 시도
    </Button>
  </ReviewDocumentMessagePanel>
);

export const ReviewDocumentEmptyState = () => (
  <ReviewDocumentMessagePanel>
    <p className="body-2-normal-regular text-label-alternative">
      표시할 DSD 내용이 없습니다.
    </p>
  </ReviewDocumentMessagePanel>
);

export const ReviewDocumentContentFrame = ({
  children,
}: {
  children: ReactNode;
}) => (
  <section className="min-h-0 flex-1 overflow-hidden bg-background-base">
    {children}
  </section>
);
